import _ from 'lodash';
import { EntityUtil } from 'gw-portals-util-js';

function InsuredSearch(data){

}

export default InsuredSearch;